import React, { useState } from "react";
import * as openpgp from "openpgp";
import "./PGPKeyGenerator.css";
import { fixArmoredPublicKey, fixArmoredPrivateKey } from "../utils/pgpHelpers";

const PGPKeyGenerator = () => {
  // State variables for user input
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [passphrase, setPassphrase] = useState("");

  // State variables for generated keys and errors
  const [publicKey, setPublicKey] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [error, setError] = useState("");

  // Generate PGP keys asynchronously
  const handleGenerateKeys = async () => {
    setError("");
    setPublicKey("");
    setPrivateKey("");

    try {
      // Generate a key pair
      const { privateKey: privKey, publicKey: pubKey } =
        await openpgp.generateKey({
          type: "rsa", // 'rsa' or 'ecc'
          rsaBits: 2048, // RSA key size
          userIDs: [{ name, email }],
          passphrase,
        });

      // Store the armored keys in state
      setPublicKey(pubKey);
      setPrivateKey(privKey);
    } catch (err) {
      setError("Key generation failed: " + err.message);
    }
  };

  const handleSaveAsText = () => {
    const toCRLF = (str) => str.replace(/\n/g, "\r\n");
    const pub = toCRLF(fixArmoredPublicKey(publicKey).trimEnd());
    const priv = toCRLF(fixArmoredPrivateKey(privateKey).trimEnd());
    const lines = ["Public Key:", pub, "", "Private Key:", priv, ""];
    const content = lines.join("\r\n");

    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "PGP_keys.txt";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="pgp-key-generator">
      <h1>PGP Key Generator</h1>

      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your name"
        />
      </div>

      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
        />
      </div>

      <div className="form-group">
        <label>Passphrase</label>
        <input
          type="password"
          value={passphrase}
          onChange={(e) => setPassphrase(e.target.value)}
          placeholder="Enter a passphrase to protect your private key"
        />
      </div>

      <button className="btn-generate" onClick={handleGenerateKeys}>
        Generate Keys
      </button>

      {error && <p className="error-message">{error}</p>}

      {publicKey && (
        <div>
          <h2>Public Key</h2>
          <textarea
            className="key-block"
            readOnly
            value={publicKey}
            rows={10}
          />
        </div>
      )}

      {privateKey && (
        <div>
          <h2>Private Key</h2>
          <textarea
            className="key-block"
            readOnly
            value={privateKey}
            rows={10}
          />
        </div>
      )}

      {(publicKey || privateKey) && (
        <button className="btn-save" onClick={handleSaveAsText}>
          Save as Text
        </button>
      )}
    </div>
  );
};

export default PGPKeyGenerator;
